import { render, staticRenderFns } from "./PartesCollapse.vue?vue&type=template&id=865be0ec&scoped=true&"
import script from "./PartesCollapse.vue?vue&type=script&lang=js&"
export * from "./PartesCollapse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "865be0ec",
  null
  
)

export default component.exports